import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=fe0a61ae"
var script = {}


/* normalize component */
import normalizer from "!../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports